import React from 'react';
import translations from '../../constants/translations.json';
import { useDataContext } from '../../context/data';

const ProfilePicture = ({ userProfile, handleChangePhoto }) => {
  const { language } = useDataContext();

  return (
    <div className="bg-white rounded-2xl py-7 shadow-sm">
      <h3 className="text-lg font-bold text-[#1a1a1a] mb-5">
        {translations[language]?.profile_picture}
      </h3>

      <div className="flex gap-6 items-center flex-wrap">
        {/* Avatar */}
        <div
          className="w-[100px] h-[100px] rounded-full shrink-0 flex items-center justify-center border-[3px] border-gray-100"
          style={
            userProfile?.profile?.avatar
              ? { background: `url(${userProfile.profile.avatar}) center/cover` }
              : { background: '#f3f4f6' }
          }
        >
          {!userProfile?.profile?.avatar && <span className="text-5xl text-gray-300">👤</span>}
        </div>

        {/* Info + button */}
        <div className="flex-1 min-w-[200px]">
          <p className="text-[13px] text-gray-400 mb-3 leading-relaxed">
            {translations[language]?.profile_change_picture_description}
          </p>
          <button
            onClick={() => document.getElementById('my_photo').click()}
            className="py-2.5 px-6 text-[13px] font-semibold bg-[#f5f5f5] text-[#333] border border-[#e0e0e0] rounded-[10px] cursor-pointer transition-all duration-200 hover:border-primary hover:text-primary"
          >
            <i className="fas fa-camera mr-2" />
            {translations[language]?.profile_change_picture}
          </button>
          <input
            type="file"
            name="my_photo"
            id="my_photo"
            className="hidden"
            accept="image/*"
            onChange={(event) => handleChangePhoto(event.target.files[0])}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfilePicture;
